export const LOGO_URL =
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmMPxHmUisIHjrUBD8Cp7Kl6uTTEoipbpgu1Xxmb8bIg&s";
export const RESTAURENT_IMAGE_CDN =
    "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const RESTAURENT_CATEGORY_IMAGE_CDN =
    "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_1024/";

export const RECIPE_IMAGE_LINK =
    "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_288,h_360/";

export const HOMEPAGE_API =
    "https://www.swiggy.com/dapi/restaurants/list/v5?lat=22.572646&lng=88.36389500000001&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";

export const RESTAURENT_INFO_API =
    "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=22.572646&lng=88.36389500000001&restaurantId=";

export const SEARCH_API =
    "https://www.swiggy.com/dapi/restaurants/search/suggest?lat=22.572646&lng=88.36389500000001&str=";
export const SEARCH_IMAGE_CDN =
    "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_112,h_112,c_fill/";

export const SEARCH_ALL_RESULT =
    "https://www.swiggy.com/dapi/restaurants/search/v3?lat=22.572646&lng=88.36389500000001&trackingId=37205c79-bb5f-c37d-844a-043914b3f7fb&submitAction=ENTER&queryUniqueId=79767bab-a282-80d3-6600-2b278300bf98&str=";

export const SEARCH_ALL_RESULT_IMAGE_CDN =
    "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";

export const FilterIcon = () => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            aria-hidden="true"
            strokeColor="rgba(2, 6, 12, 0.92)"
            fillColor="rgba(2, 6, 12, 0.92)"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.3996 5.99897C13.3996 6.66172 12.8623 7.19897 12.1996 7.19897C11.5368 7.19897 10.9996 6.66172 10.9996 5.99897C10.9996 5.33623 11.5368 4.79897 12.1996 4.79897C12.8623 4.79897 13.3996 5.33623 13.3996 5.99897ZM14.9996 5.99897C14.9996 7.54537 13.746 8.79897 12.1996 8.79897C10.9311 8.79897 9.85962 7.95547 9.51546 6.79878L1.80875 6.79878C1.36692 6.79878 1.00875 6.44061 1.00875 5.99878C1.00875 5.55695 1.36692 5.19878 1.80875 5.19878L9.51558 5.19878C9.85986 4.04228 10.9312 3.19897 12.1996 3.19897C13.746 3.19897 14.9996 4.45258 14.9996 5.99897ZM3.8 13.4527C3.13726 13.4527 2.6 12.9154 2.6 12.2527C2.6 11.59 3.13726 11.0527 3.8 11.0527C4.46274 11.0527 5 11.59 5 12.2527C5 12.9154 4.46274 13.4527 3.8 13.4527ZM3.8 15.0527C2.2536 15.0527 1 13.7991 1 12.2527C1 10.7063 2.2536 9.45271 3.8 9.45271C5.0683 9.45271 6.13964 10.296 6.48396 11.4524H14.1953C14.6372 11.4524 14.9953 11.8106 14.9953 12.2524C14.9953 12.6942 14.6372 13.0524 14.1953 13.0524H6.48414C6.14001 14.2092 5.06852 15.0527 3.8 15.0527Z"
                fill="rgba(2, 6, 12, 0.92)"
                fill-opacity="0.92"
            ></path>
        </svg>
    );
};

export const EMPTY_CART_IMAGE =
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSASbSZgbOxruhNsu0o5-fajPoWLjIJCJL7yZbvcDDfnQihmBO";

export const SIGNIN_LOGO_CDN =
    "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/Image-login_btpq7r";

export const REGX_FOR_MOBILE_DEVICE = /android|iphone|kindle|ipad/i;

export const USER_AGENT = window.navigator.userAgent;
export const DEFAULT_PROFILE =
    "https://img.freepik.com/premium-vector/anonymous-user-circle-icon-vector-illustration-flat-style-with-long-shadow_520826-1931.jpg?w=740";
